<template>
  <ring-loader :size="size" color="currentColor" :class="current ? '' : `tw-text-${color}`" />
</template>

<script>
import { RingLoader } from "vue-spinners-css";

export default {
  components: {
    RingLoader,
  },
  props: {
    size: {
      type: Number,
      default: 36,
    },
    color: {
      type: String,
      default: "primary",
    },
    current: Boolean,
  },
};
</script>
